import { createAsyncThunk, ThunkDispatch } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { loadRdsTracks } from "../rds/rdsActionsTrack";
import { Country, Provider } from "../../interfaces/dtos/common";
import { RootState } from "../store";
import axios from "axios";
import { fileVersionAppendix } from "../../utils/commonUtils";

// Every screen we will impliment multiple reducer items, we would always want to do certain actios like load rds tracks etc etc
export const actionReducerItems = async (
    // allow parameter to be any
    // eslint-disable-next-line
    dispatch: ThunkDispatch<any, any, any>,
    loadingParam: boolean,
    setLoadingFunction: (loading: boolean) => void,
    process: () => Promise<void>
) => {
    if (loadingParam) {
        return; // already fetching
    }

    try {
        dispatch(setLoadingFunction(true));

        // we always want to load tracks
        dispatch(loadRdsTracks());

        await process();

    } catch (ex) {
        await dispatch(setError(ex));
    } finally {
        dispatch(setLoadingFunction(false));
    }
}

// Menu Expanded
export const setMenuExpanded = createAsyncThunk(
    'common/menuExpanded',
    async (expanded: boolean) => {
        return expanded;
    }
);

// List Expanded
export const setListExpanded = createAsyncThunk(
    'common/listExpanded',
    async (expanded: boolean) => {
        return expanded;
    }
);

// loadCountries
export const loadCountries = createAsyncThunk(
    'common/loadCountries',
    async () => {
        const result =  await axios.get<Country[]>(`/countries.json${fileVersionAppendix()}`)
        return result.data.toSorted((a,b) => a.name < b.name ? -1 : 1);
    },
    {
        condition: (_, { getState }) => {
            // If we already have countries then no need to get them again
            const rootState = getState() as RootState;
            if (!rootState) { return true; }
            if (rootState.common.loadingCountries) { return false; }  // already loading
            return rootState.common.countries.length === 0;
        }
    }
);

// loadProviders
export const loadProviders = createAsyncThunk(
    'common/loadProviders',
    async () => {

        // TODO: Is it only going to be BM and PA or will there be an endpoint to get a list?
        const providers: Provider[] = [
            { code: "betmakers", description: "Betmakers" },
            { code: "PA", description: "PA" }
        ]

        return providers;
    },
    {
        condition: (_, { getState }) => {
            // If we already have providers then no need to get them again
            const rootState = getState() as RootState;
            if (!rootState) { return true; }
            if (rootState.common.loadingProviders) { return false; }  // already loading
            return rootState.common.providers.length === 0;
        }
    }
);

// Set Error
export const setError = createAsyncThunk(
    'common/setError',
    async (ex: unknown) => {
        if (ex instanceof Error) {
            return ex.message;
        } else {
            return ex as string;
        }
    }
);

// Reset Errors
export const resetErrors = createAsyncThunk(
    'common/resetErrors',
    async () => {
        return;
    }
);

// Logout
export const logoutReducers = createAsyncThunk(
    'common/logoutReducers',
    async () => {
        return;
    }
);

export const dateInReloadRange = (date: Date | string) => {
    const dateFormat = "YYYYMMDD";
    // If the date is greater than yesterday, then always reload (as the values might have changed)
    return (dayjs(date).format(dateFormat) >= dayjs().subtract(1, 'day').format(dateFormat))
}

export const getDateKey = (date: Date | string) => {
    return dayjs(date).format("YYYYMMDD");
}
